import { render, staticRenderFns } from "./GBRightPane.vue?vue&type=template&id=59712a9e&"
import script from "./GBRightPane.vue?vue&type=script&lang=js&"
export * from "./GBRightPane.vue?vue&type=script&lang=js&"
import style0 from "./GBRightPane.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib'
installComponents(component, {VDialog})
